import { jsx as _jsx } from "react/jsx-runtime";
const TabPanel = ({ children, value, index, ...rest }) => (_jsx("div", { hidden: value !== index, ...rest, children: children }));
export { TabPanel };
